export enum ChangeType
{
    Increased = "Increased",
    Decreased = "Decreased",
    Any = "Any",
}